export default {"src":"/_next/static/media/puzzle-sm.4a760a6b.svg","height":154,"width":153,"blurWidth":0,"blurHeight":0};